import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantsService, PreferenceListItem } from '../services/constants.service';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'returnHomeFreq',
  standalone: false,
})
export class ReturnHomeFreqPipe implements PipeTransform {
  private map$: Observable<Record<number, PreferenceListItem>>;

  constructor(private constantsService: ConstantsService) {
    this.map$ = this.constantsService.driverReturnHomeChoicesMap$;
  }

  public transform(value: number): Observable<string> {
    return this.map$.pipe(
      map((cm) => {
        return cm[value]?.label || '';
      }),
    );
  }
}
